<template>
  <gj-modal
      notFooterPadding
      size="1200_auto"
      :class="modalClass"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增否定商品投放</template>
    <template #content>
<!--      <p>{{form | json}}</p>-->
      <el-form
          ref="form"
          :model="form">
        <app-base-info
            ref="base"
            :market-id="marketId"
            :form="form.baseInfoForm"
            :campaign-target-type="isMeaningless(campaign)"
            :campaign-target-type-option="[
              {id: AdGroupEnum.SP.targetingType.AUTO, text: '自动投放'},
              {id: AdGroupEnum.SP.targetingType.PRODUCT, text: '商品投放'},
            ]"
            :campaign="campaign"
            :group="group"
            group-select
        ></app-base-info>
        <app-auto-neg-target-picker
            v-if="form.baseInfoForm.campaignTargetType === AdGroupEnum.SP.targetingType.AUTO"
            ref="picker"
            :market-id="marketId"
            :form="form.autoTargetPickerForm"
            title="否定商品"
        ></app-auto-neg-target-picker>
        <app-manual-neg-target-picker
            v-if="form.baseInfoForm.campaignTargetType === AdGroupEnum.SP.targetingType.PRODUCT"
            ref="picker"
            :market-id="marketId"
            :form="form.manualTargetPickerForm"
            title="否定商品"
        ></app-manual-neg-target-picker>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {isMeaningfulMixin, isMeaninglessMixin, modalMixIn} from "@/minxins";
  import AppBaseInfo from "../common/base-info";
  import AppAutoNegTargetPicker from "../common/auto-neg-target-picker";
  import {addSpAdNegTarget, SP} from "@/api/ad";
  import {AdCampaignEnum, AdGroupEnum} from "../../../../../common/enum";
  import AppManualNegTargetPicker from "../common/manual-neg-target-picker";
  import {isMeaningful} from "@/utils/common";

  export default {
    name: "app-add-sp-ad-neg-target",
    mixins: [modalMixIn, isMeaninglessMixin, isMeaningfulMixin],
    components: {AppManualNegTargetPicker, AppAutoNegTargetPicker, AppBaseInfo},
    props: {
      marketId: {
        required: true
      },
      campaign: {
        required: false,
        default: null
      },
      group: {
        required: false,
        default: null
      }
    },
    data() {
      return {
        form: {
          baseInfoForm: {
            campaignTargetType: null,
            campaignId: null,
            groupId: null,
          },
          autoTargetPickerForm: {
            items: []
          },
          manualTargetPickerForm: {
            items: []
          }
        },
        AdGroupEnum: AdGroupEnum
      }
    },
    watch: {
      campaign: {
        handler: function(campaign) {
          if (this.isMeaningful(campaign)) {
            if (campaign.targetingType === AdCampaignEnum.SP.targetingType.MANUAL) {
              this.form.baseInfoForm.campaignTargetType = AdGroupEnum.SP.targetingType.PRODUCT;
            } else if (campaign.targetingType === AdCampaignEnum.SP.targetingType.AUTO) {
              this.form.baseInfoForm.campaignTargetType = AdGroupEnum.SP.targetingType.AUTO;
            }
          } else {
            this.form.baseInfoForm.campaignTargetType = AdGroupEnum.SP.targetingType.AUTO;
          }
        },
        immediate: true
      }
    },
    computed: {
      modalClass() {
        if (this.isMeaningful(this.group)) {
          return 'gj-modal_1220X630';
        } else if (this.isMeaningful(this.campaign)) {
          return 'gj-modal_1220X674';
        } else {
          return 'gj-modal_1060X699';
        }
      },
    },
    methods: {
      confirm() {
        this.confirmLoading = true;
        let formValid = ['base', 'picker']
          .map(e => this.$refs[e]?.formValidate());
        Promise.all([...formValid])
          .then(() => this.negativeTargetsAdd())
          .catch((error) => console.log('zs', error))
          .complete(() => this.confirmLoading = false)
      },
      negativeTargetsAdd() {
          this.confirmLoading = true;
          const params = {
            marketId: this.marketId,
          };
          if (this.form.baseInfoForm.campaignTargetType === AdGroupEnum.SP.targetingType.AUTO) {
            params.params = this.form.autoTargetPickerForm.items.map(e => ({
              campaignId: this.form.baseInfoForm.campaignId,
              groupId: this.form.baseInfoForm.groupId,
              targetingType: 1,
              asin: e.asin
            }));
          } else if (this.form.baseInfoForm.campaignTargetType === AdGroupEnum.SP.targetingType.PRODUCT) {
            params.params = this.form.manualTargetPickerForm.items.map(e => {
              const params = {
                campaignId: this.form.baseInfoForm.campaignId,
                groupId: this.form.baseInfoForm.groupId,
                targetingType: 0
              };
              if (isMeaningful(e.asin)) {
                params.asin = e.asin;
              }
              if (isMeaningful(e.brandId)) {
                params.brandId = e.brandId;
                params.brandName = e.brandName;
              }
              return params;
            });
          }
          SP.negativeTargetsAdd(params)
            .then(() => {
              this.$gjDestroy();
              this.$emit('created');
            })
            .complete(() => this.confirmLoading = false);
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";

</style>
